document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".rich-text .rte").forEach((textEl) => {
    const sectionEl = textEl.closest(".rich-text");
    if (sectionEl && sectionEl.getAttribute("data-enable-read-more") === "false") {
      return;
    }

    const LINES = 2;   // change to 2 lines

    // Wrap text
    const wrapper = document.createElement("div");
    wrapper.className = "read-more-wrapper";

    textEl.parentNode.insertBefore(wrapper, textEl);
    wrapper.appendChild(textEl);

    // Apply clamp
    textEl.style.display = "-webkit-box";
    textEl.style.webkitBoxOrient = "vertical";
    textEl.style.webkitLineClamp = LINES;
    textEl.style.overflow = "hidden";

    // ---- CHECK IF OVERFLOW EXISTS ----
    const isOverflowing = textEl.scrollHeight > textEl.clientHeight;

    // If no overflow, do NOT create Read more
    if (!isOverflowing) return;

    // Create toggle
    const toggle = document.createElement("span");
    toggle.className = "read-more-inline";
    toggle.textContent = "Read more";

    wrapper.appendChild(toggle);

    let expanded = false;

    toggle.addEventListener("click", () => {
      expanded = !expanded;
      textEl.style.webkitLineClamp = expanded ? "unset" : LINES;
      toggle.textContent = expanded ? "Read less" : "Read more";
    });
  });
});
